import React from "react";

const CardSubsection = ({
    heading, 
    icon,
    mainText, 
}) => {
    return (
        <>
            <h4 style={{ marginBottom: '1rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                {icon}
                </span>
                {heading}
            </h4>
            <p> {mainText} </p>
        </>
    )
}

export default CardSubsection;